module.exports = __webpack_public_path__ + "img/4_CN_ChineseMicrosite_Homepage_HeroImage.fd851a1c.jpg";